import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import styles from './CardIconButton.module.scss';

const CardIconButton = ({ renderIcon, className, size = '20px', ...props }) => {
  return (
    <Button
      {...props}
      style={{
        ...props.style,
        '--size': size,
      }}
      className={cn(styles.root, className)}
    >
      {renderIcon()}
    </Button>
  );
};

export default CardIconButton;
